var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n    Copyright\n    "),_c('a-icon',{attrs:{"type":"copyright"}}),_vm._v("\n    "+_vm._s(new Date().getFullYear())+"\n    "),_c('span',[_vm._v("杭州爱华智能科技有限公司")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }